<template>
  <div class="maincen">
    <div class="catalog">
      <!-- <div class="line"></div> -->
      <div class="catalogTit">教材出版</div>
    </div>
    <div class="center">
      <div class="contentpub">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="教师姓名：" prop="nickname">
            <el-input
              :disabled="true"
              v-model="resnickname"
              placeholder="请输入教师姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="phone">
            <el-input
              v-model="resPhone"
              :disabled="true"
              placeholder="请输入您的手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作单位：">
            <el-input
              :disabled="true"
              v-model="resSchName"
              placeholder="请输入您的工作单位"
            ></el-input>
          </el-form-item>
          <el-form-item label="职称：">
            <el-input
              :disabled="true"
              v-model="professional"
              placeholder="请输入您的职位"
            ></el-input>
          </el-form-item>
          <el-form-item label="出版类型:" prop="textbookType">
            <el-select
              v-model="ruleForm.textbookType"
              placeholder="请选择出版类型"
            >
              <el-option
                v-for="(item, index) in provinceData"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划书名：" prop="projectTitle">
            <el-input
              show-word-limit
              :maxlength="30"
              v-model="ruleForm.projectTitle"
              placeholder="请输入计划书名"
            ></el-input>
          </el-form-item>
          <el-form-item label="选题名称：" prop="topicName">
            <el-input
              show-word-limit
              :maxlength="30"
              v-model="ruleForm.topicName"
              placeholder="请输入选题名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="内容摘要：" prop="synopsis">
            <el-input
              type="textarea"
              :rows="5"
              show-word-limit
              :maxlength="100"
              v-model="ruleForm.synopsis"
              placeholder="请输入内容摘要"
            ></el-input>
          </el-form-item>
          <el-form-item label="出版内容及特色价值：" prop="publishContent">
            <el-input
              type="textarea"
              :rows="5"
              show-word-limit
              :maxlength="100"
              v-model="ruleForm.publishContent"
              placeholder="请输入出版内容及特色价值"
            ></el-input>
          </el-form-item>
          <el-form-item label="申请说明：" prop="auditExplain">
            <el-input
              type="textarea"
              :rows="5"
              v-model="ruleForm.auditExplain"
              placeholder="请输入申请说明"
            ></el-input>
          </el-form-item>
          <el-form-item prop="manuscriptUrl" label="上传稿件：">
            <div class="head">
              <!-- <div class="uploadkey">上传稿件：</div> -->
              <div class="uploaddiv">
                <el-upload
                  :action="getUrl"
                  :on-success="handleAvatarSuccess"
                  :on-remove="removeManuscript"
                  :before-upload="beforeUpload"
                  name="file"
                  :on-progress="progress"
                  :data="picUpload"
                  accept=".zip, .rar"
                >
                  <el-button class="uploadbutton" size="small" type="primary"
                    >点击上传稿件</el-button
                  >
                  <span slot="tip" class="el-upload__tip">
                    只能仅支持zip或rar文件，且不超过100M
                  </span>
                </el-upload>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="picUrl" label="上传配套资源：">
            <div class="head">
              <!-- <div class="uploadkey">上传配套资源：</div> -->
              <div class="uploaddiv">
                <el-upload
                  :action="getUrl"
                  :on-success="handleAvatarSuccess2"
                  :on-remove="removeResource"
                  :before-upload="beforeUpload"
                  name="file"
                  :on-progress="progress"
                  :data="picUpload"
                  accept=".zip , .rar"
                >
                  <el-button class="uploadbutton" size="small" type="primary"
                    >点击上传配套资源</el-button
                  >
                  <span slot="tip" class="el-upload__tip">
                    只能仅支持zip或rar文件，且不超过100M
                  </span>
                </el-upload>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="buttonfooter">
          <el-button
            :loading="isLoading"
            class="preservesave commonbook left"
            @click="submitForm('ruleForm')"
          >
            保存
          </el-button>
          <el-button
            class="preservecancle commonbook left"
            @click="cancle('ruleForm')"
          >
            取消
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from '../../assets/api/axios'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { baseUrl } from '@/config.js'
import { getzhichengStr } from '../../assets/tool'
import { savePublish } from '../../api/wapi'
export default {
  computed: {
    ...mapGetters([
      'resPhone',
      'resSchName',
      'resnickname',
      'resProfessional',
      '',
    ]),
  },
  data() {
    return {
      timer: null,
      isLoading: false,
      second: 60,
      getzhichengStr: getzhichengStr,
      isShowCodeBtn: true,
      getUrl: `${baseUrl}/aliyun/oss/uploadFiles`,
      activeName: 'first',
      ruleForm: {
        auditExplain: '', // 申请说明
        manuscriptFileName: '', // 稿件名称
        manuscriptFileSize: '', //
        manuscriptUrl: '', // 稿件url
        projectTitle: '', //计划书名
        publishContent: '', // 出版内容
        resourceFileName: '', //配套资源名称
        resourceFileSize: '', // 配套资源
        resourceUrl: '', // 配套资源url
        synopsis: '', //内容提要
        textbookType: '', // 出版教材类型
        topicName: '', // 选题名称
      },
      changePasswordForm: {},
      isPhone: false,
      rules: {
        topicName: [
          { required: true, message: '请输入选题名称', trigger: 'blur' },
        ],
        textbookType: [
          { required: true, message: '请选择出版类型', trigger: 'change' },
        ],
        manuscriptUrl: [
          { required: true, message: '请上传稿件资源', trigger: 'change' },
        ],
        projectTitle: [
          { required: true, message: '请输入计划书名', trigger: 'blur' },
        ],
        publishContent: [
          { required: true, message: '请输入出版内容', trigger: 'blur' },
        ],
        synopsis: [
          { required: true, message: '请输入内容摘要', trigger: 'blur' },
        ],
        auditExplain: [
          { required: true, message: '请输入申请说明', trigger: 'blur' },
        ],
      },
      imageUrl: '',
      schList: [],
      options: regionData,
      // headerUrl: { Authorization: window.localStorage.getItem('Token') },
      picUpload: { serviceName: 'teacher' },
      provinceData: [
        { value: 8, label: '一般教材' },
        { value: 5, label: '省规划教材' },
      ],
      colleges: [],
      major: [],
      isDisable: false,
      professional: '',
    }
  },
  created() {
    this.professional = getzhichengStr(this.resProfessional)
    console.log('获取数据====>', this.resPhone, this.resProfessional)
  },
  methods: {
    cancle() {
      this.$router.back()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm)
          this.isLoading = true
          savePublish(this.ruleForm)
            .then((result) => {
              console.log('result=====>', result)
              this.isLoading = false
              this.$router.go(-1)
            })
            .catch((err) => {
              this.isLoading = false
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    removeManuscript() {
      this.ruleForm.manuscriptFileName = ''
      this.ruleForm.manuscriptFileSize = ''
      this.ruleForm.manuscriptUrl = ''
    },
    removeResource() {
      this.ruleForm.resourceFileName = ''
      this.ruleForm.resourceFileSize = ''
      this.ruleForm.resourceUrl = ''
    },
    //上传
    handleAvatarSuccess(res, file) {
      if (res.status == 0) {
        this.ruleForm.manuscriptUrl = res.data.url
        this.ruleForm.manuscriptFileSize = res.data.size
        this.ruleForm.manuscriptFileName = res.data.fileName
      } else {
        this.$message(res.msg)
      }
    },
    handleAvatarSuccess2(res, file) {
      if (res.status == 0) {
        this.ruleForm.resourceUrl = res.data.url
        this.ruleForm.resourceFileSize = res.data.size
        this.ruleForm.resourceFileName = res.data.fileName
      } else {
        this.$message(res.msg)
      }
    },
    beforeUpload(file,fileList){
      console.log("文件===》",file);
      const jpegOrpng = (file.name.includes('.zip') || file.name.includes('.rar'));
      if (!jpegOrpng) {
        this.$message.info('只能仅支持zip或rar文件');
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 100
      if (!isLt5M) {
        this.$message.info('上传文件大小不能超过 100MB!');
        return false
      }
    },
    progress(event, file, fileList) {
      console.log(file)
    },
    // beforeAvatarUpload(file) {
    //   const isLt2M = file.size / 1024 / 1024 < 2
    //   if (!isLt2M) {
    //     this.$message.error('上传头像图片大小不能超过 2MB!')
    //   }
    //   return isLt2M
    // },
  },
}
</script>
<style lang="scss" scoped>
.maincen{
  background-color: white;
  padding: 0px 20px;
  text-align: center;
}
.catalog{
  padding: 20px 0px 5px;
  border-bottom: 1px solid #e6e6e6;
}
.contentpub {
  width: 700px;
  margin-top: 20px;
  margin: 0 auto;
  padding-top: 50px;
}
.buttonfooter {
  height: 40px;
  padding-top: 50px;
  padding-bottom: 65px;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.demo-ruleForm /deep/.el-form-item__content{
  text-align: left;
}
.uploadkey {
  width: 160px;
  float: left;
  font-size: 16px;
  color: #606266;
}
.itemnewImg {
  margin-top: 10px;
  width: 100%;
  height: 117px;
  img {
    height: 100%;
    width: 100%;
  }
}
.addImg {
  margin-top: 10px;
  width: 185px;
  height: 117px;
  margin-bottom: 60px;
  img {
    height: 100%;
    width: 100%;
  }
}
.itemTit {
  font-size: 16px;
  color: #0082F0;
  margin: 17px 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 30px;
  cursor: pointer;
  &:hover {
    color: #0082F0;
  }
}
.preservesave {
  border: 1px solid #0082F0;
  background: #0082F0;
  // &:hover {
  //   color: #0082F0;
  //   background-color: #f8cecb;
  //   border: 1px solid #b3352e;
  // }
}
.commonbook {
  width: 100px;
  border-radius: 0px;
  // height: 36px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  // line-height: 36px;
  margin: 50px 0 80px;
  cursor: pointer;
}
.preservecancle {
  background: #e6e6e6;
  margin-left: 20px;
  font-size: 14px;
  font-family: Noto Sans S Chinese;
  font-weight: 500;
  color: #666666;
  &:hover {
    color: #666666;
    background-color: #e6e6e6;
    border: 1px solid #e6e6e6;
  }
}

.phonesend {
  width: 150px;
  height: 37px;
  background: rgba(252, 252, 252, 1);
  border-left: 1px solid rgba(230, 230, 230, 1);
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  line-height: 38px;
  position: absolute;
  top: 3px;
  right: 188px;
  cursor: pointer;
}
</style>
<style lang="scss">
@import '../../assets/css/centertabs.scss';

.uploadbutton {
  width: 140px;
  height: 40px;
  background: #ffffff !important;
  border: 1px solid #0082F0 !important;
  text-align: center !important;
}
.uploaddiv {
}
.uploadbutton span {
  text-align: center;
  font-size: 14px;
  font-family: Noto Sans S Chinese;
  font-weight: 500;
  color: #0082F0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-left: 10px;
  // border-radius: 50%;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px !important;
  color: #8c939d;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>
